module.exports = __webpack_public_path__ + "static/profile-b968cb0212b512c2074e9a6986385011.png";